import Drumpad from "./components/Drumpad";
function App() {
  return (
    <div className="App">
      <Drumpad />
    </div>
  );
}

export default App;
